import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
const Title = styled.div `
  ${({ theme }) => theme.typography.type141};
  overflow: hidden;
  height: 40px;
  display: block;
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-overflow: ellipsis;
`;
const CardTitle = ({ title, elipsTitleLength = 100, }) => {
    let elipsizedText = title;
    if ((title) && (title.length > elipsTitleLength)) {
        elipsizedText = `${title.substr(0, elipsTitleLength)}...`;
    }
    return (React.createElement(Title, null, elipsizedText));
};
export default CardTitle;
